import script from "./AltaPay.vue?vue&type=script&lang=ts&setup=true"
export * from "./AltaPay.vue?vue&type=script&lang=ts&setup=true"

import "./AltaPay.vue?vue&type=style&index=0&id=56f89551&lang=less"

const __exports__ = script;

export default __exports__